import { Navigate, useLocation } from "react-router-dom";
import type { Path } from "@/router";

export default function McpPlaygroundRedirect() {
  const location = useLocation();

  return <Navigate to={{ pathname: "/dev/chat" as Path, search: location.search, hash: location.hash }} replace />;
}
